import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { signOut, getAuth } from 'firebase/auth';
import { initializeApp, getApps, getApp } from 'firebase/app';
import firebaseConfig from './components/firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/base.scss';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import FeaturedStories from './components/FeaturedStories';
import Trails from './components/Trails';
import BeyondWatching from './components/BeyondWatching';
import Testimonials from './components/Testimonials';
import Partners from './components/Partners';
import AppCTA from './components/AppCTA';
import Education from './components/Education';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AuthPage from './components/AuthPage';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Schools from './pages/Schools';

const Home = () => (
  <>
    <Hero />
    <HowItWorks />
    <FeaturedStories />
    <Trails />
    <BeyondWatching />
    <Testimonials />
    <Partners />
    <AppCTA />
    <Education />
  </>
);

function App() {
  const [show, setShow] = useState("none");
  const [user, setUser] = useState(() => {
    try {
      return localStorage.getItem("auth") ? true : false;
    } catch (error) {
      console.warn('localStorage not available:', error);
      return false;
    }
  });
  const [signOutUrl, setSignOutUrl] = useState("about:blank");

  // Standalone sign-out path for the header's profile dropdown — mirrors the
  // login/logout token-push pattern inside AuthPage.js (hidden iframe hands
  // the admin app a signout token) without touching that already-fragile
  // component (see CLAUDE.md §6/§7).
  const handleSignOut = async () => {
    let auth = null;
    try {
      auth = getAuth(getApps().length ? getApp() : (firebaseConfig.apiKey ? initializeApp(firebaseConfig) : null));
    } catch (error) {
      console.warn('Firebase auth unavailable:', error);
    }
    if (!auth) {
      localStorage.clear();
      setUser(false);
      return;
    }
    try {
      await signOut(auth);
    } catch (error) {
      console.warn('Sign out failed:', error);
    }
    setSignOutUrl("https://admin.yesterdaystories.net.au/pushLoginAuth.html?token=signout");
    localStorage.clear();
    setUser(false);
  };

  return (
    <Router>
      <ScrollToTop />
      <Header user={user} setShow={setShow} onSignOut={handleSignOut} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/schools" element={<Schools />} />
      </Routes>
      <Footer />
      <AuthPage show={show} setShow={setShow} user={user} setUser={setUser} />
      <iframe src={signOutUrl} title="hidden sign-out consumer" style={{ display: "none" }}></iframe>
    </Router>
  );
}

export default App;
